import cloudStyleConfig from '@shared/styles/antd-style.json';
import partnerStyleConfig from '@sharedPartner/styles/antd-style.json';

import _ from 'lodash';

let config =
  import.meta.env.PUBLIC_PARTNER_MODE !== 'cloud' ? _.merge(cloudStyleConfig, partnerStyleConfig) : cloudStyleConfig;

export default config;
